import { vuexHandbook } from '@/store/composition/handbook'
import { FlatnessApi } from '@/api/handbook/position/Flatness/FlatnessApi'

const state = () => ({
  ...vuexHandbook.createState(),
  api: FlatnessApi
})

const getters = {
  ...vuexHandbook.createGetters()
}

const mutations = {
  ...vuexHandbook.createMutations()
}

const actions = {
  ...vuexHandbook.createActions()
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
